import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import MySelect from '../../../../UI/form/MySelect'
import { setSupplyBillsFiltersStatus } from '../../../../../store/supplyBillSlice'

const SupplyBillsFilterStatus = () => {

    const status = useSelector(state => state.supplyBill.supplyBills.filters.status)
	const dispatch = useDispatch()

  	const [value, setValue] = useState(status)
  	const [validSelect, setValidSelect] = useState(false)
	const [options, setOptions] = useState([
		{
			id: 'work',
			name: 'В роботі'
		},
		{
			id: 'success',
			name: 'Успішні'
		},
		{
			id: 'cancel',
			name: 'Скасовані'
		},
		{
			id: 'all',
			name: 'Всі'
		},
	])

  return (
    <MySelect
        value={value}
        label="Статус"
        labelId="select__statusFilter-label"
        id='select__statusFilter'
        onChange = {e => {
            setValue(e)
			dispatch(setSupplyBillsFiltersStatus(e))
			// setEvent({...event, categoryId: e})
		}}
        nameField='Статус'
        // sx={{width: '200px'}}
        options={
			options && options.length > 0 ? 
				options.map(option => {
            		return {id: option.id, name: option.name}
				})
			: []	
		}
        // options={[]}
    />
  )
}

export default SupplyBillsFilterStatus